/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_BadgeInputs */

const es_cap_jpc_badge = /** @type {(inputs: Cap_Jpc_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva propuesta`)
};

const gl_cap_jpc_badge = /** @type {(inputs: Cap_Jpc_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova proposta`)
};

const en_cap_jpc_badge = /** @type {(inputs: Cap_Jpc_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New proposal`)
};

/**
* | output |
* | --- |
* | "New proposal" |
*
* @param {Cap_Jpc_BadgeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_badge = /** @type {((inputs?: Cap_Jpc_BadgeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_BadgeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_badge(inputs)
	if (locale === "en") return en_cap_jpc_badge(inputs)
	return es_cap_jpc_badge(inputs)
});